import { useEffect, useMemo, useState, useRef } from "react";
import { Canvas } from "@react-three/fiber";
import { useLoader } from "@react-three/fiber";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader";
import { BrightnessContrast } from "@react-three/postprocessing";
import * as THREE from 'three';
import {
  OrbitControls,
  Stage,
  useProgress,
  Html
} from "@react-three/drei";
// import { SpotLightHelper } from 'drei';
import { EffectComposer, Bloom } from "@react-three/postprocessing";
import axios from "axios";
import environmentVariables from "../../../config/environmentVariables";
import { PlaneGeometry } from "three";
// import Model from './Model'
const ModalBack = `${environmentVariables?.cdnUrl}modal_back.hdr`

export default function ThreejsImageMelee({ detailOfNftCentral }) {
  // const [skinID, setSkinID] = useState(detailOfNftCentral?.skinId);
  const [loadingError, setLoadingError] = useState(false);
  const [url, setUrl] = useState(null);
  const [minDistance, setMinDistance] = useState(20);
  const [screenwidth, setScreenwidth] = useState(window.innerWidth);
  useEffect(() => {
    console.log(window.innerWidth, "innerwidthinsidethreejs");
    const handleResize = () => {
      setScreenwidth(window.innerWidth);
      if (window.innerWidth <= 768) {
        setMinDistance(20);
      } else if (window.innerWidth > 768 && window.innerWidth <= 1100) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(15);
      } else if (window.innerWidth > 1100 && window.innerWidth <= 1200) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(55);
      } else if (window.innerWidth > 1200 && window.innerWidth <= 1300) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(50);
      } else if (window.innerWidth > 1300 && window.innerWidth <= 1400) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(45);
      } else if (window.innerWidth > 1400 && window.innerWidth <= 1600) {
        console.log(minDistance, "heremindistanceiscalled");
        setMinDistance(40);
      } else if (window.innerWidth > 1600 && window.innerWidth <= 1920) {
        setMinDistance(20);
      }
    };
    handleResize();
  }, []);
  // console.log(detailOfNftCentral?.skinId, "skin id in three js");
  // useEffect(() => {
  //   if (detailOfNftCentral) {
  //     setUrl(
  //       `https://marketplace-metaspace.b-cdn.net/modelswithskinid/${detailOfNftCentral?.skinId}.glb`
  //     );
  //   }
  //   return () => {
  //     setUrl(null);
  //   };
  // }, [detailOfNftCentral]);
  useEffect(() => {
    if (detailOfNftCentral && detailOfNftCentral?.skinId) {
      axios
        .get(
          `${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.glb`
        )
        .then((res) => {
          setLoadingError(false);
          setUrl(
            `${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.glb`
          );
        })
        .catch((err) => {
          setLoadingError(true);
          setUrl(null);
        });
    }
  }, [detailOfNftCentral]);
  // const url = skinID
  //   ? `https://marketplace-metaspace.b-cdn.net/modelswithskinid/${skinID}.glb`
  //   : `${environmentVariables?.apiUrl}/${detailOfNftCentral?.image}`;
  const NewModel =
    detailOfNftCentral &&
    url &&
    (() => {
      const { scene } = useLoader(GLTFLoader, url);
      const copiedScene = useMemo(() => scene.clone(), [scene]);
      // console.log(detailOfNftCentral, "detailofnftinthreejsmodel");
      const modelRef = useRef();
      return (
        <>
          <mesh
            ref={modelRef}
            castShadow // Enable casting shadows
            receiveShadow // Enable receiving shadows
          >
            <primitive
              castShadow
              object={copiedScene}
              scale={55}
              position={[0, 0, 0]}
              rotation={[0, Math.PI / 2 + 0.4, 0]}
            />
          </mesh>
        </>
      );
    });

  function Loader() {
    const { progress } = useProgress();
    return (
      <Html
        center
        style={{
          color: "#bfbfbf",
          fontSize: "80px",
          fontWeight: "700",
          textAlign: "center",
          opacity: "0.5",
        }}
      >
        {parseInt(progress)}%
      </Html>
    );
  }

  // function PlaneWithShadows() {
  //   return (
  //     <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0,-9,0]}>
  //     <planeGeometry args={[20, 20]} />
  //     <meshStandardMaterial color="#daa520" />
  //     <AccumulativeShadows temporal frames={100} color="orange" colorBlend={2} toneMapped={true} alphaTest={0.75} opacity={2} scale={12}>
  //         <RandomizedLight intensity={Math.PI} amount={8} radius={4} ambient={0.5} position={[5, 5, -10]} bias={0.001} />
  //       </AccumulativeShadows>
  //   </mesh>
  //   );
  // }

  return (
    <div className="App">
      <Canvas
        className="model-canvas"
        // gl={{ antialias: false, preserveDrawingBuffer: true}}
        shadows
        shadowMap
        camera={{ fov: 25, position: [0, 0, 28] }}
      >
        <group position={[0, 2, 0]}>
          {loadingError ? (
            <Html
              center
              style={
                {
                  // height: "100%",
                  // width:"300px"
                }
              }
            >
              <img
                src={`${environmentVariables?.cdnUrl}${detailOfNftCentral?.skinId}.png`}
                alt="NFT Image"
              />
            </Html>
          ) : (
            <>{NewModel && <NewModel />}</>
          )}
          {/* <AccumulativeShadows resolution={1024} frames={100} color="#0c575f" alphaTest={0.68} colorBlend={1.5} opacity={1.65} scale={8}>
          <RandomizedLight radius="30" ambient="2.6" position={[20, 15, 10]} bias={0.001} />
        </AccumulativeShadows> */}
        {/* <ambientLight intensity={0.5} /> */}
      {/* <directionalLight position={[0, 60, 0]} intensity={1} castShadow /> */}
        </group>
        {/* <Environment files={ModalBack} background blur={0.4} /> */}
        <spotLight position={[0, 15, 1]} angle={Math.PI / 6} penumbra={0.2} intensity={1} castShadow color={"#dddddd"}/>
        <spotLight position={[0, 20, 1]} angle={Math.PI / 6} penumbra={0.2} intensity={1} castShadow  color={"#dddddd"}/>
        {/* angle={Math.PI / 6} */}
        {/* <SpotLightHelper /> */}
        {/* <pointLight position={[0, 0, -10]} intensity={2} color="grey" /> */}
        {/* <pointLight position={[0, 0, -10]} intensity={1} color="grey" /> */}
        {/* <pointLight position={[50, -10, 5]} intensity={2} color="#070c48" /> */}
        {/* <pointLight position={[0, 0, -10]} intensity={1} color="#070c48" /> */}
        {/* <pointLight position={[0, 10, 0]} intensity={10} color="grey" /> */}
        {/* <fog attach="fog" args={['black', 50, 21.5]} /> */}
        {/* <ambientLight intensity={1}/> */}
        {/* <ambientLight intensity={3}  position={[0, 0, -10]}/> */}
        {/* <directionalLight intensity={2.25} color="grey" position={[0, 0, 5]} castShadow/> */}
        {/* <directionalLight intensity={2.25} color="grey" position={[0, 0, -5]} castShadow/> */}
        {/* <directionalLight intensity={2.25} color="grey" position={[0, -5, 10]} castShadow/> */}
        {/* <directionalLight
        position={[0, 10, 0]}
        intensity={0.4}
        castShadow // Enable casting shadows
        shadow-mapSize-width={1024} // Optional: Higher resolution shadow map
        shadow-mapSize-height={1024} // Optional: Higher resolution shadow map
      /> */}
        {/* <directionalLight
        position={[5, 10, 5]}
        intensity={5}
        castShadow // Enable casting shadows
        shadow-mapSize-width={1024} // Optional: Higher resolution shadow map
        shadow-mapSize-height={1024} // Optional: Higher resolution shadow map
      />
        <directionalLight
          position={[5, 10, 5]}
          intensity={5}
          castShadow // Enable casting shadows
          shadow-mapSize-width={1024} // Optional: Higher resolution shadow map
          shadow-mapSize-height={1024} // Optional: Higher resolution shadow map
        /> */}

        {/* <spotLight
          intensity={1}
          position={[0, -10, 0]}
          angle={Math.PI / 4}
          penumbra={1}
          castShadow
        /> */}
        {/* <directionalLight intensity={5} color="grey" position={[0, 2, -5]} /> */}
        {/* <directionalLight intensity={2.25} color="grey" position={[-20, 0, 0]} /> */}
        {/* <directionalLight intensity={1.5} color="red" position={[30, 0, 0]} /> */}

        {/* <Environment preset="dawn" background blur={1} /> */}

        {/* <Suspense styled={{ zIndex: "0.5" }} fallback={<Loader />}> */}

        {/* Ground plane */}
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, -6, 0]}>
        <planeGeometry args={[500, 500]} />
        <meshPhongMaterial attach="material" color="#e4e2e7" />
      </mesh>
      {/* rotation={[-Math.PI / 2, 0, 0]} */}
      {/* Sphere */}
      <mesh receiveShadow position={[0, 4.5, 0]} castShadow>
        <sphereGeometry args={[100, 32, 32]} />
        <meshPhongMaterial attach="material" color="#908e92" side={THREE.DoubleSide}>
        <texture url={ModalBack} />
        </meshPhongMaterial>
       
      </mesh>



        <Stage
          castShadow
          receiveShadow
          intensity={detailOfNftCentral?.category == "uncommon" ? 1 : 1}
          adjustCamera={false}
        ></Stage>
        <OrbitControls
          autoRotate
          autoRotateSpeed={1.7}
          enableZoom={true}
          minDistance={minDistance}
          maxDistance={60}
          makeDefault
        />

        {/* <AccumulativeShadows>
          <RandomizedLight position={[2, 5, 5]} />
        </AccumulativeShadows> */}

        {detailOfNftCentral?.category == "common" && (
          <EffectComposer disableNormalPass multisampling={8}>
            <Bloom
              luminanceThreshold={5}
              mipmapBlur
              luminanceSmoothing={3}
              intensity={1}
            />
            <BrightnessContrast
              brightness={0} // brightness. min: -1, max: 1
              contrast={0.2} // contrast: min -1, max: 1
            />
          </EffectComposer>
        )}

        {/* {loadingError ? (
            <Html
              center
              style={{
                height: "100%",
              }}
            >
              <img
                src={`${environmentVariables?.apiUrl}/${detailOfNftCentral?.image}`}
                alt="NFT Image"
              />
            </Html>
          ) : (
            <>{NewModel && <NewModel />}</>
          )} */}
        {/* </Suspense> */}
      </Canvas>
    </div>
  );
}
